import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar fixed-top navbar-expand-md navbar-light" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "navbar-brand",
  href: "/"
}, "bagrat saatsazov", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, " menu ", -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarNav",
  ref: "navbar"
}
const _hoisted_6 = { class: "navbar-nav ms-auto" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("home")
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("portfolio")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("about")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("ul", _hoisted_6, [
          _createVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/portfolio"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ])
      ], 512)
    ])
  ]))
}